import request from "../request"

const apiChat = {
    // 新增聊天
    post: (queryParams) => request.post('/v1/nf/chat', queryParams),

    // 聊天记录
    history: (receiveId) => request.get(`/v1/nf/chat/record/receive/${receiveId}`),

    // 发送消息
    send: (queryParams) => request.post(`/v1/nf/chat/record`, queryParams),

}


const chat = {
    apiChat,
}

export default chat
